import { atom } from 'recoil';
import { RECOIL_KEY } from './key';
/**
 * 判断页面是否是从rn-webview进入
 */
export const isRNWebView = atom({
    key: RECOIL_KEY.IS_RN_WEBVIEW,
    default: false
});
